import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App, { ScrollToTop } from './App';
import './index.css';

// Initialize i18n
import './i18n';

// Enhanced ScrollToTop wrapper
const ScrollToTopWrapper = () => {
  return (
    <>
      <ScrollToTop />
    </>
  );
};

createRoot(document.getElementById('root')!).render(
  <React.Fragment>
    <HelmetProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <ScrollToTopWrapper />
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.Fragment>
);

// Register service worker for performance
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        // Check for updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New service worker is available, force update
                newWorker.postMessage({ type: 'SKIP_WAITING' });
                window.location.reload();
              }
            });
          }
        });
        
        // Force update if needed
        if (registration.waiting) {
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
          window.location.reload();
        }
      })
      .catch((registrationError) => {
        // Service worker registration failed
      });
  });
}